// These functions are untestable, so they have been moved to a separate file and excluded from test coverage

import * as jose from 'jose';
import { DebugService } from './debug.service.js';

class _EncryptionService {
  constructor() {
    this.debugService = new DebugService('DecryptionService');
  }

  async generateKeyPairs() {
    return jose.generateKeyPair('ECDH-ES', { extractable: true });
  }

  async compactDecrypt(encryptedFile, privateKey) {
    const decryptedValue = await jose.compactDecrypt(encryptedFile, privateKey);
    return decryptedValue.plaintext;
  }
}

export const EncryptionService = new _EncryptionService();
